import React from "react"
import type { DadosPedidoFornecedorModel } from "../models/dadosPedidoFornecedorModel"
import { DadosPedidoFornecedorInicial } from "../models/dadosPedidoFornecedorModel"
import type { DadosPedidoFornecedorActions } from "./dadosPedidoFornecedorActions"

type DadosPedidoFornecedorContextType = {
    dados: DadosPedidoFornecedorModel
    dispatch: React.Dispatch<DadosPedidoFornecedorActions>
    pesquisar: () => Promise<void>
    erroCarregamento: string | null
}

export const DadosPedidoFornecedorContext =
    React.createContext<DadosPedidoFornecedorContextType>({
        dados: DadosPedidoFornecedorInicial,
        dispatch: () => undefined,
        pesquisar: async () => undefined,
        erroCarregamento: null,
    })
